import { createRouter, createWebHistory } from "vue-router";
import routes from "./routes";
import { waitForHydration } from "@/utils/auth";


const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.name === 'concert') {
            return false;
        }
        if (from && from.name === 'concert' && to.name === 'home') {
            return false;
        }
        return { top: 0 };
    }
});

// Säkerställ att roller/venue är hämtade från /api/auth/me innan någon
// route-guard fattar beslut. Utan detta kan första render av /admin köra
// med tom roll-state och skicka användaren till /.
router.beforeEach(async (to, from, next) => {
    await waitForHydration();
    next();
});

// Sidor som inte ska spåras (admin-verktyg och autentiseringsflöden)
const EXCLUDED_PREFIXES = ["/admin", "/login", "/register", "/auth-callback"];

// SPA-tracking: vid varje route-byte spårar vi sidvisningen på två sätt:
//   1. Eget server-side analytics (cookieless, GDPR-friendly, alltid aktivt)
//   2. GA4 (styrs av Consent Mode — cookies sätts bara om användaren accepterat)
router.afterEach((to) => {
  const excluded = EXCLUDED_PREFIXES.some((prefix) =>
    to.path.startsWith(prefix)
  );

  if (!excluded) {
    // --- 1. Eget analytics-ping (cookieless, kräver inget samtycke) ---
    const device = /Mobi|Android/i.test(navigator.userAgent)
      ? "mobile"
      : "desktop";
    fetch(process.env.VUE_APP_API_URL + "analytics/pageview", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: to.path, device }),
    }).catch(() => {}); // fire-and-forget
  }

  // --- 2. GA4 SPA-tracking ---
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }
  // setTimeout 0 så document.title hinner uppdateras av nästa vy
  // (Vue uppdaterar title efter route-bytet, inte före).
  setTimeout(() => {
    window.gtag("event", "page_view", {
      page_path: to.fullPath,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, 0);
});

export default router;
